// 认证相关工具函数
import axios from 'axios'

const TOKEN_KEY = 'authToken'
const USERNAME_KEY = 'username'
const LOGIN_TIME_KEY = 'loginTime'
const TOKEN_EXPIRES_AT_KEY = 'tokenExpiresAt'

/**
 * 检查用户是否已登录
 * @returns {boolean}
 */
export function isLoggedIn() {
  return Boolean(getAuthToken()) && !isLoginExpired()
}

/**
 * 获取当前登录用户名
 * @returns {string|null}
 */
export function getCurrentUser() {
  return localStorage.getItem(USERNAME_KEY)
}

/**
 * 获取登录时间
 * @returns {string|null}
 */
export function getLoginTime() {
  return localStorage.getItem(LOGIN_TIME_KEY)
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function getAuthHeaders(extraHeaders = {}) {
  const token = getAuthToken()
  return {
    ...extraHeaders,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  }
}

export async function login(username, password) {
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ username, password })
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok || !data.token) {
    throw new Error(data.error || '登录失败')
  }

  const now = Date.now()
  localStorage.setItem(TOKEN_KEY, data.token)
  localStorage.setItem(USERNAME_KEY, data.username || username)
  localStorage.setItem(LOGIN_TIME_KEY, new Date(now).toISOString())
  localStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(now + (data.expiresIn || 86400) * 1000))

  return data
}

export async function authFetch(url, options = {}) {
  const headers = getAuthHeaders(options.headers || {})
  const response = await fetch(url, {
    ...options,
    headers
  })

  if (response.status === 401) {
    logout()
  }

  return response
}

/**
 * 登出用户
 */
export function logout() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USERNAME_KEY)
  localStorage.removeItem(LOGIN_TIME_KEY)
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
}

/**
 * 检查登录是否过期
 * @returns {boolean}
 */
export function isLoginExpired() {
  const expiresAt = Number(localStorage.getItem(TOKEN_EXPIRES_AT_KEY) || 0)
  if (!expiresAt) return true
  return Date.now() >= expiresAt
}

/**
 * 验证用户权限（目前只有一个管理员角色）
 * @returns {boolean}
 */
export function hasPermission() {
  return isLoggedIn() && !isLoginExpired()
}

export function setupAxiosAuth() {
  axios.interceptors.request.use((config) => {
    const token = getAuthToken()
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        logout()
      }
      return Promise.reject(error)
    }
  )
}
